const SIDE_BAR_WIDTH = 301;
const SIDE_BAR_COLLAPSE_WIDTH = 65;
const TOP_BAR_HEIGHT = 68;

export { SIDE_BAR_WIDTH, SIDE_BAR_COLLAPSE_WIDTH, TOP_BAR_HEIGHT }